import {Helmet} from '@dr.pogodin/react-helmet';
import {openDeleteDialog} from 'platform/components';
import {match} from 'ts-pattern';

import {isArray} from 'ramda-adjunct';

import {useDeleteGeneralSettingMutation} from '@dms/api/core';
import i18n from '@dms/i18n';
import {settingsRoutes, testIds} from '@dms/routes';
import {SettingsTemplate} from '@dms/settings/shared';
import {catchUnhandledDataGridActions, DmsDataGrid, handleApiError} from '@dms/shared';

import {composePath, useNavigate} from 'shared/web';

import type {ActionCallback} from 'features/eag-grid';

export function TiresInventory() {
  const navigate = useNavigate();

  const [deleteGeneralSetting] = useDeleteGeneralSettingMutation();

  const actionCallback: ActionCallback = ({actionKey, rowId, refreshData}) => {
    const id = isArray(rowId) ? rowId[0] : rowId;

    match(actionKey)
      .with('redirectDetail', 'edit', () =>
        navigate(composePath(settingsRoutes.tiresInventoryDetail, {params: {id}}))
      )
      .with('delete', () =>
        openDeleteDialog({
          onConfirm: () =>
            deleteGeneralSetting({generalSettingId: id})
              .unwrap()
              .then(() => refreshData())
              .catch(handleApiError),
        })
      )
      .otherwise(() => catchUnhandledDataGridActions(actionKey));
  };

  return (
    <>
      <Helmet title={i18n.t('general.labels.general')} />
      <SettingsTemplate
        header={{
          title: i18n.t('general.labels.general'),
          actions: [
            {
              type: 'button',
              title: i18n.t('entity.tiresInventory.labels.newSettings'),
              onClick: () => navigate(settingsRoutes.tiresInventoryCreate),
            },
          ],
        }}
        description={i18n.t('entity.tiresInventory.labels.generalDescription')}
        data-testid={testIds.settings.tiresInventory('template')}
      >
        <DmsDataGrid
          gridCode="tire-setting"
          actionCallback={actionCallback}
          data-testid={testIds.settings.tiresInventory('datagrid')}
        />
      </SettingsTemplate>
    </>
  );
}
